import type { TFunction } from 'i18next';
import type { NudgePayload, ReviewAskNudgeId } from '@bt-common/nudges/nudge.types';

/**
 * Localized review-ask copy (namespace `common`); the server's EN copy is the defaultValue fallback.
 * Every key is a string literal so the translation-keys-exist gate can see it.
 */
export function reviewAskCopy(
  t: TFunction,
  nudgeId: ReviewAskNudgeId,
  payload: Pick<NudgePayload, 'headline' | 'body' | 'vars'>,
): { headline: string; body: string } {
  const body = { defaultValue: payload.body };
  const headline = { defaultValue: payload.headline, count: payload.vars?.contactCount };
  const sendsHeadline = { defaultValue: payload.headline, count: payload.vars?.sendCount };
  switch (nudgeId) {
    case 'review_ask_sends_2026q4':
      return { headline: t('reviewAsk.sendsHeadline', sendsHeadline), body: t('reviewAsk.sendsBody', body) };
    case 'review_ask_renewal_2026q4':
      return { headline: t('reviewAsk.renewalHeadline', headline), body: t('reviewAsk.renewalBody', body) };
    case 'review_ask_campaign_2026q4':
      return { headline: t('reviewAsk.campaignHeadline', headline), body: t('reviewAsk.campaignBody', body) };
  }
}
